/**
 * 预览弹框组件
 * @author chenqunfeng
 * @since 17/11/14
 */

import './video-dialog.less';

import React from 'react';

import PreviewAuthInfo from 'components/preview/auth-info';
import PreviewIframe from 'components/preview/iframe';
import PreviewVideoForwardView from 'components/preview/video-forward-view';
import PreviewOperationBar from 'components/preview/operation-bar';
import PreviewPrice from 'components/preview/price';
import PreviewBuybtn from 'components/preview/buy-btn';

export function getPreviewLeft(opts) {
  const { tplData } = opts;
  const { title } = tplData;

  return (
    <div className="s-preview-video-left">
      <div className="s-preview-video-lt">
        <div className="s-preview-video-title">{title}</div>
        <PreviewAuthInfo
          data={tplData}
          newClassName={'s-preview-video-auth-info'}
        />
      </div>
      <PreviewIframe
        data={tplData}
        needLoading={true}
        newClassName={'s-preview-video-iframe'}
      />
    </div>
  );
}

export function getPreviewRight(opts) {
  const {
    tplData,
    state,
    userInfo,
    getBuyState,
    buyTemplate,
    buyLocalTemplate,
    setTplCollectionStatus,
  } = opts;
  const { coupon, buyState } = state;

  return (
    <div className="s-preview-video-right">
      <PreviewVideoForwardView data={tplData} />
      <PreviewOperationBar
        data={tplData}
        userInfo={userInfo}
        setTplCollectionStatus={setTplCollectionStatus}
        newClassName={'s-preview-video-operation'}
      />
      <PreviewPrice
        data={tplData}
        coupon={coupon}
        newClassName={'s-preview-video-price'}
      />
      <PreviewBuybtn
        data={tplData}
        coupon={coupon}
        userInfo={userInfo}
        buyState={buyState}
        getBuyState={getBuyState}
        buyTemplate={buyTemplate}
        buyLocalTemplate={buyLocalTemplate}
        newClassName={'s-preview-video-buy-btn'}
      />
    </div>
  );
}
